<div class="modal-header">
    <span class="modal-header-title"> {{ 'DIALOG.SETTING_PRODUCT_LIST_ATTRIBUTE_MODEL' | translate }}</span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div class="col-12">
                <div class="form-group">
                    <div class="form-group">
                        <label class="filter-label" for="attribute_id_field"> {{ 'Список атрибутов' | translate }}</label>
                        <ng-select id="attribute_id_field"
                         class="custom" 
                         clearAllText="{{ 'CLEAR' | translate }}"
                         notFoundText="{{ 'NO_DATA' | translate }}" 
                         bindLabel="name" 
                         bindValue="id"
                         formControlName="attribute_id" 
                         groupBy="attribute_group_name"
                         [multiple]="true" 
                         [closeOnSelect]="false"
                         [items]="attributes" 
                         appendTo="body"
                         >
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{index}}" type="checkbox"
                                    [checked]="item$.selected" />&nbsp;
                                <span>{{item.name}}</span>
                            </ng-template>
                        </ng-select>


                        <!-- <app-editable-content 
                        *ngIf="attr.editable" 
                        class="attr-text-info-edit"
                        [inputValue]="{presetContentType: attr.present_type_id, presetContentId: attr.preset_content_id, displayContentValue: attr.display_value, contentValue: attr.value, actions: true }"
                        (outputValue)="updateList(i, j, product, attr, $event)"
                        (outputReject)="rejectEdit(attr)">
                        </app-editable-content> -->
                    </div>
                </div>
            </div>   

        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-light btn-back"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
    <button type="button" class="btn btn-primary btn-create" (click)="onCreateAndSendAttrsData()">{{ 'SAVE'| translate}}</button>
</div>